// PopUp video code start
$(document).ready(function(){
  $('.video_slider_play_btn').click(function(){
    $('.custom_popup_video_parent').css('display','flex');
    $('.video_popup_close_btn').css('display','flex');
    var videourl = $(this).attr('data_video_url');
    var iframe = $(this).html();
    if(iframe != ' '){       
      $('.custom_popup_video_parent').html(iframe);
      $(".custom_popup_video_parent iframe")[0].src += "&autoplay=1";
      $('body').css('overflow','hidden');
    }else{
    $('.custom_popup_video_parent').html(`<video crossorigin="anonymous"  controls="" >
      <source src="${videourl}" type="video/mp4"></video>`);
      $('body').css('overflow','hidden');
      $('.custom_popup_video_parent video').trigger('play');
    }
  })
  $('.video_popup_close_btn').click(function(){
    $('.custom_popup_video_parent').css('display','none');
    $('.video_popup_close_btn').css('display','none');
    $('.custom_popup_video_parent').html('');
    $('body').css('overflow','unset');
  })
})
// Popup video code end
// Announcement Bar Start
$(document).ready(function(){
  $('.announcment_bar_close').click(function(){
      $('.announcement_bar_section').css('display','none');
  })
})
// Announcement Bar End
// FAQ Start
$(document).ready(function () {
  $(".home_faq_heading").click(function () {
    $(this).next().slideToggle(400);
    $(this).find(".home_faq_arrow").toggleClass("active");
  });
});
// FAQ End